import { Helmet } from "react-helmet";
import Header from "../../../Components/Header";
import AssemblyForm from "./AssemblyForm";


const ViewAssembly = () => {
  return (
    <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
      <Helmet>
				<title>Work Order - View</title>
			</Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column" style={{flexGrow:'1'}}>
        <AssemblyForm />
      </div>
    </div>
  );
};

export default ViewAssembly;
